import type { RootState } from '@/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { rolesApi } from '../api';
import type { RoleOption } from '../types';

export const useOwnRoleLevel = () => {
  const currentUser = useSelector((state: RootState) => state.users.currentUser);
  const [roles, setRoles] = useState<RoleOption[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    void rolesApi
      .getOptions()
      .then((options) => {
        if (active) setRoles(options);
      })
      .catch(() => {
        if (active) setError('Failed to load roles.');
      });
    return () => {
      active = false;
    };
  }, []);

  const ownLevel =
    roles &&
    Math.max(
      0,
      ...roles
        .filter((option) => currentUser?.roles.some((item) => item.name === option.name))
        .map((option) => option.level),
    );

  return { ownLevel, error };
};
